export default function IconLockSquare({ className }: { className?: string }) {
  // Ported from the old planner icon (frontend app/components/icons/lock-square.hbs),
  // used to mark private comments. Uses currentColor so the surrounding CSS controls the color.
  return (
    <svg
      version="1.1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={className}
    >
      <path d="M12,19.5c-0.276,0 -0.5,-0.224 -0.5,-0.5v-2.586c-0.59,-0.209 -1,-0.774 -1,-1.414c0,-0.827 0.673,-1.5 1.5,-1.5c0.827,0 1.5,0.673 1.5,1.5c0,0.64 -0.41,1.205 -1,1.414v2.586c0,0.276 -0.224,0.5 -0.5,0.5Zm0,-5c-0.276,0 -0.5,0.224 -0.5,0.5c0,0.276 0.224,0.5 0.5,0.5c0.276,0 0.5,-0.224 0.5,-0.5c0,-0.276 -0.224,-0.5 -0.5,-0.5Z" />
      <path d="M4.5,24c-0.827,0 -1.5,-0.673 -1.5,-1.5v-12c0,-0.827 0.673,-1.5 1.5,-1.5h1.5v-3c0,-3.308 2.692,-6 6,-6c3.308,0 6,2.692 6,6v3h1.5c0.827,0 1.5,0.673 1.5,1.5v12c0,0.827 -0.673,1.5 -1.5,1.5h-15Zm0,-14c-0.276,0 -0.5,0.224 -0.5,0.5v12c0,0.276 0.224,0.5 0.5,0.5h15c0.276,0 0.5,-0.224 0.5,-0.5v-12c0,-0.276 -0.224,-0.5 -0.5,-0.5h-15Zm12.5,-1v-3c0,-2.757 -2.243,-5 -5,-5c-2.757,0 -5,2.243 -5,5v3h10Z" />
    </svg>
  )
}
